export default {
    card: {
        title: 'SEO',
        sharedNote: 'Robots, canonical and the Open Graph image are shared by every language and are edited on the {locale} tab.',
    },
    fields: {
        metaDescription: 'Meta description',
        robots: 'Robots',
        canonical: 'Canonical override',
        ogImage: 'Open Graph image',
        jsonLd: 'JSON-LD',
    },
    hints: {
        length: 'Optimal length is {min}–{max} characters',
    },
    jsonLd: {
        custom: 'Custom override',
        auto: 'Auto-generated',
        reset: 'Reset to auto',
        overrideHint: 'Edit to override. Saving an unchanged auto value reverts to auto so future improvements still apply.',
        translationHint: "Leave empty to use the {locale} document with this language's URL and title.",
    },
};
